import { Center, Loader } from '@mantine/core';

/**
 * Shown while a lazily-loaded route module is in flight, and while an auth
 * guard is still deciding.
 *
 * Deliberately one component for both, so a route that has to fetch its chunk
 * before an auth check looks identical to one waiting on the check itself —
 * the user sees one spinner, not two different ones in sequence. It is one
 * component rather than a copied fragment for the reason the previous copies
 * demonstrate: they were Tailwind utility classes against a Tailwind that
 * emitted no CSS, so all four rendered an empty div and none of them showed a
 * spinner at all. A single implementation is one place to be wrong.
 *
 * There is no viewport-height variant because no caller owns the viewport: the
 * router has exactly two top-level routes, `Layout` and `NoAuthLayout`, and
 * every guard renders as a child of one of them. A `100vh` box under a header
 * that is already painted is a header taller than the screen.
 */
export function RouteFallback() {
  return (
    <Center mih="60vh" role="status" aria-label="Loading page">
      <Loader size="lg" />
    </Center>
  );
}
